import { BookingIcon, CodifyLogo, FacebookIcon, FooterColumn, FooterCopyright, FooterCredit, FooterIcons, FooterLogo, FooterSection, FooterWrapper, HomeButton, InstagramIcon, PolicyLink } from "./styled";
import { ReactComponent as ArrowIcon } from "./arrow.svg";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../config/links";
import { scroller } from "react-scroll";

const Footer = () => {

    const { t, i18n } = useTranslation();
    const year = new Date().getFullYear();
    const policyPath = (i18n.resolvedLanguage || i18n.language)?.startsWith("en")
        ? "/privacy-policy"
        : "/polityka-prywatnosci";

    return (
        <FooterSection id="footer">
            <HomeButton
                type="button"
                aria-label={t("footer.backToTop")}
                onClick={() =>
                    scroller.scrollTo("home", {
                        smooth: true,
                        duration: 600,
                        offset: -90,
                    })
                }
            >
                <ArrowIcon />
            </HomeButton>
            <FooterWrapper>
                <FooterLogo aria-label="Czorsztynianka logo" />

                <FooterColumn>
                    <FooterIcons>
                        <a
                            href={LINKS.external.facebook}
                            target="_blank"
                            title={t("footer.social.facebook")}
                            aria-label={t("footer.social.facebook")}
                            rel="noreferrer"
                        >
                            <FacebookIcon />
                        </a>

                        <a
                            href={LINKS.external.instagram}
                            target="_blank"
                            title={t("footer.social.instagram")}
                            aria-label={t("footer.social.instagram")}
                            rel="noreferrer"
                        >
                            <InstagramIcon />
                        </a>
                                                <a
                            href={LINKS.external.housesBooking}
                            target="_blank"
                            title={t("footer.social.instagram")}
                            aria-label={t("footer.social.instagram")}
                            rel="noreferrer"
                        >
                            <BookingIcon />
                        </a>
                    </FooterIcons>
                    <PolicyLink
                        to={policyPath}
                    >
                        {t("footer.privacyLink")}
                    </PolicyLink>

                </FooterColumn>

                <FooterCopyright>

                    <span>{t("footer.copyright", { year })}</span>

                    <FooterCredit
                        href={LINKS.external.codify}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Codify"
                        aria-label="Codify"
                    >
                        <div>{t("footer.credit")}</div>
                        <div>
                            <CodifyLogo />
                        </div>
                    </FooterCredit>
                </FooterCopyright>
            </FooterWrapper>
        </FooterSection>
    );
};


export default Footer;